import React, { Component } from 'react';

import StandardETL from './routes/standardETL';
import EtlConfig from './routes/etlConfiguration/UploadConfig';

import { store } from './store';

export default class Root extends Component {
  constructor() {
    super();
    this.state = {};
  }
  componentDidMount() {
    // disable legacy css
    window.datashop.app.module('disableOldCss')();
  }

  componentToRender = (name) => {
    switch (name) {
      case 'l3_l5_process_node':
        return <EtlConfig />;
      case 'l5_standard_etl':
        return <StandardETL />;
      default:
        return <h5>No match</h5>;
    }
  };
  render() {
    const { componentName } = this.props;
    return <div className="h-100">{this.componentToRender(componentName)}</div>;
  }
}
